module.exports = __webpack_public_path__ + "img/card_lie_up.abd3d6d0.gif";